import React, { lazy, Suspense, Fragment } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
//import Pricing from "../components/Pricing/Pricing";
const Pricing = lazy(() =>
  import(/* webpackChunkName: "Pricing" */ "../components/Pricing/Pricing")
);

// Mui stuff
import { Typography } from "@mui/material";

import { makeStyles } from "tss-react/mui";

// redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()(() => ({
  pricingDiv: {
    padding: "0px 15px 15px 15px",
    textAlign: "center",
  },
  headingDiv: {
    paddingTop: 30,
    paddingBottom: 30,
  },
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function pricing() {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Pricing - Content Generator`}
        description={`Choose the perfect marketing plan for your business. From basic post creation to advanced automation, our flexible pricing includes ai functionality, post generation and scheduling tools.`}
        url={`https://contentgenerator.io/pricing`}
      />
      <div className={classes.pricingDiv}>
        {ExecutionEnvironment.canUseDOM && (
          <Suspense fallback={<div />}>
            <Pricing />
          </Suspense>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps)(pricing);
